/** @format */

import { useEffect, useState } from 'react'
import localize from '../../../../../../../Global/Localize'
import { getData } from '../../../../../../../Helpers/webApi'
import SpecimenMediaItem from '../../../../../../Registry/Members/Partials/Tabs/SpecimenMediaItem'

/* eslint-disable */

function ChequeSpecimen({ journal }) {
  const query = {
    frontImage1: journal?.frontImage1Id,
    frontImage2: journal?.frontImage2Id,
    rearImage: journal?.rearImageId,
  }

  const [media, setMedia] = useState({
    frontImage1: null,
    frontImage2: null,
    rearImage: null,
  })

  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    loadAllMedia()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [journal])

  async function loadAllMedia() {
    for (let i = 0; i < Object.values(query).length; i++) {
      const imageData = await loadMedia(
        Object.values(query)[i],
        Object.keys(query)[i]
      )

      if (imageData) {
        setMedia(media => ({
          ...media,
          [Object.keys(query)[
            i
          ]]: `data:${imageData.ContentType};base64,${imageData.content}`,
        }))
      }
    }
  }

  async function loadMedia(sku, key) {
    if (sku) {
      setIsBusy(key)
      const { success, data } = await getData(
        '/base64/get-media-by-sku',
        {
          sku,
        },
        false
      )
      if (success) {
        setIsBusy(null)
        return data
      } else {
        setIsBusy(null)
        return null
      }
    } else {
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-between mb-5">
      {Object.entries(query).map(([key, value]) => (
        <div
          className="spec-item-add-customer"
          key={`spec-item-add-customer-${key}-${value}`}
        >
          <label className="mb-2 text-capitalize">{localize(key)}</label>
          <SpecimenMediaItem
            isBusy={isBusy === key}
            readOnly
            itemKey={key}
            base64={journal ? media[key] : null}
          />
        </div>
      ))}
    </div>
  )
}

export default ChequeSpecimen
